/* eslint-disable @typescript-eslint/no-explicit-any */

import type { BaseErrorResponse, ExportOperationParams, GetTransactionsRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useWalletOperation() {
  class WalletOperation<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Wallet operation
     * @name WalletOperationControllerGetWalletOperations
     * @summary Returns transaction log
     * @request GET:/api3/wallet-operation
     * @secure
     * @response `200` `GetTransactionsRes`
     * @response `400` `BaseErrorResponse`
     */
    walletOperationControllerGetWalletOperations = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /**
         * Operation type ID
         * @example 1
         */
        operationTypeId?: number;
        /**
         * Operation type IDs
         * @example [1,2]
         */
        operationTypeIds?: string[];
        /**
         * Payment system ID
         * @example 1
         */
        paymentSystemId?: number;
        /**
         * Payment rule ID
         * @example 1
         */
        paymentRuleId?: number;
        /**
         * Currency
         * @example "USD"
         */
        currencyId?: string;
        /**
         * Wallet ID
         * @example 1
         */
        walletId?: number;
        /**
         * Date
         * @example "2021-10-01"
         */
        start?: any;
        /**
         * Date
         * @example "2021-10-01"
         */
        end?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTransactionsRes, BaseErrorResponse>({
        path: '/api3/wallet-operation',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Wallet operation
     * @name WalletOperationControllerExportWalletOperations
     * @summary Returns transaction log
     * @request POST:/api3/wallet-operation/export
     * @secure
     * @response `200` `GetTransactionsRes`
     * @response `400` `BaseErrorResponse`
     */
    walletOperationControllerExportWalletOperations = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit?: number;
        /**
         * @min 0
         * @example 0
         */
        page?: number;
        /**
         * Operation type ID
         * @example 1
         */
        operationTypeId?: number;
        /**
         * Operation type IDs
         * @example [1,2]
         */
        operationTypeIds?: string[];
        /**
         * Payment system ID
         * @example 1
         */
        paymentSystemId?: number;
        /**
         * Payment rule ID
         * @example 1
         */
        paymentRuleId?: number;
        /**
         * Currency
         * @example "USD"
         */
        currencyId?: string;
        /**
         * Wallet ID
         * @example 1
         */
        walletId?: number;
        /**
         * Date
         * @example "2021-10-01"
         */
        start?: any;
        /**
         * Date
         * @example "2021-10-01"
         */
        end?: any;
      },
      data: ExportOperationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTransactionsRes, BaseErrorResponse>({
        path: '/api3/wallet-operation/export',
        method: 'POST',
        query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new WalletOperation();
}
